import apiService from "../common/commonApi";

export const leaveHoliday = {};

leaveHoliday.getHoliday = async (param) => {
    return apiService.Get("getHoliday", param);
};

leaveHoliday.createHoliday = async (param) => {
    return apiService.Post("createHoliday", param);
};

leaveHoliday.deleteHoliday = async (param) => {
    return apiService.Post("deleteHoliday", param);
};

leaveHoliday.updateHoliday = async (param) => {
    return apiService.Post("updateHoliday", param);
};
